export const ACTIVE_THUMB = 'responsive-carousel__thumb--active';
export const CAROUSEL_CLASSNAME = 'responsive-carousel__slider';
export const HAS_CAROUSEL = 'data-has-carousel';
